import type { EventPayload, RunRecord, RunState } from '@orgsim/shared';

type Props = {
  run: RunRecord;
  state: RunState;
  readOnly: boolean;
  dispatch: (p: EventPayload) => void;
};

export function InjectsPanel({ run, state, readOnly, dispatch }: Props) {
  return (
    <ul className="space-y-2">
      {run.scenario.injects.map((i) => {
        const done = state.triggeredInjects.includes(i.id);
        return (
          <li
            key={i.id}
            className={`rounded border p-2 ${done ? 'border-neutral-800 opacity-60' : 'border-neutral-700'}`}
          >
            <div className="flex items-center justify-between">
              <span className="font-medium">{i.title}</span>
              {done ? (
                <span className="text-xs text-neutral-400">ausgelöst</span>
              ) : !readOnly ? (
                <button
                  type="button"
                  onClick={() => dispatch({ type: 'InjectTriggered', injectId: i.id })}
                  className="rounded bg-red-600 px-2 py-0.5 text-xs text-black"
                >
                  Auslösen
                </button>
              ) : null}
            </div>
            <p className="mt-1 whitespace-pre-wrap text-neutral-300">{i.text}</p>
            {i.effects?.length ? (
              <p className="mt-1 text-xs text-neutral-500">
                {i.effects.length} Wirkung(en) auf Karte oder Kräfte
              </p>
            ) : null}
          </li>
        );
      })}
      {run.scenario.injects.length === 0 ? (
        <li className="text-neutral-500">Keine Einspieler im Szenario.</li>
      ) : null}
    </ul>
  );
}
